import { useMemo } from 'react'

import { isFileAttachment, isImageMimeType } from '../MessageListingAttachments'
import { BLACKLISTED_MIME_TYPES } from './constants'
import { buildAttachmentId } from '../helpers'
import type { FileAttachmentItem, UseFileAttachmentsParams } from '../types'

export const useFileAttachments = ({
  attachments,
}: UseFileAttachmentsParams): FileAttachmentItem[] => {
  const fileAttachmentItems = useMemo(() => {
    if (!attachments?.length) {
      return [] as FileAttachmentItem[]
    }
    return attachments
      .filter(isFileAttachment)
      .filter((attachment) => !isImageMimeType(attachment.type))
      .filter((attachment) => {
        const normalizedMime = attachment.type?.trim().toLowerCase()
        if (!normalizedMime) {
          return true
        }

        return !BLACKLISTED_MIME_TYPES.has(normalizedMime)
      })
      .map((attachment, index) => ({
        id: buildAttachmentId({
          hash: attachment.hash,
          url: attachment.url,
          index,
        }),
        url: attachment.url,
        name: attachment.name,
        mimeType: attachment.type,
      }))
  }, [attachments])

  return fileAttachmentItems
}
